var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideReportOrng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66668 4.79167H5.75001C5.24168 4.79167 4.75417 4.9936 4.39472 5.35305C4.03528 5.71249 3.83334 6.2 3.83334 6.70833V18.2083C3.83334 18.7167 4.03528 19.2042 4.39472 19.5636C4.75417 19.9231 5.24168 20.125 5.75001 20.125H11.2096M7.66668 4.79167C7.66668 4.28334 7.86861 3.79582 8.22806 3.43638C8.5875 3.07693 9.07501 2.875 9.58334 2.875H11.5C12.0083 2.875 12.4959 3.07693 12.8553 3.43638C13.2147 3.79582 13.4167 4.28334 13.4167 4.79167M7.66668 4.79167C7.66668 5.3 7.86861 5.78751 8.22806 6.14695C8.5875 6.5064 9.07501 6.70833 9.58334 6.70833H11.5C12.0083 6.70833 12.4959 6.5064 12.8553 6.14695C13.2147 5.78751 13.4167 5.3 13.4167 4.79167M17.25 13.4167V17.25H21.0833M17.25 13.4167C18.2667 13.4167 19.2417 13.8205 19.9606 14.5394C20.6795 15.2583 21.0833 16.2333 21.0833 17.25M17.25 13.4167C16.2333 13.4167 15.2583 13.8205 14.5394 14.5394C13.8205 15.2583 13.4167 16.2333 13.4167 17.25C13.4167 18.2667 13.8205 19.2417 14.5394 19.9606C15.2583 20.6795 16.2333 21.0833 17.25 21.0833C18.2667 21.0833 19.2417 20.6795 19.9606 19.9606C20.6795 19.2417 21.0833 18.2667 21.0833 17.25M17.25 10.5417V6.70833C17.25 6.2 17.0481 5.71249 16.6886 5.35305C16.3292 4.9936 15.8417 4.79167 15.3333 4.79167H13.4167M7.66668 10.5417H11.5M7.66668 14.375H10.5417",
    stroke: "#0d99ff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideReportOrng);
export default __webpack_public_path__ + "static/media/sideReportOrng.781b8b72662aee6397904fd425e52980.svg";
export { ForwardRef as ReactComponent };